module.exports = __webpack_public_path__ + "img/foodBySharks.5b744bcd.jpg";